import { Stack } from "@mui/material";
import { FC } from "react";
import { LiveUsageMgmtResourcesCount } from "./LiveUsageMgmtResourcesCount";
import { LiveUsageResourceFilter } from "./LiveUsageResourceFilter";
import { ResourceType } from "@/services/cloudchipr.api";
import { useAppSelector } from "@/store/hooks";
import { isLiveUsageMgmtFilterAppliedToResourceSelector } from "@/store/live-usage-mgmt/selectors/isLiveUsageMgmtFilterAppliedToResourceSelector";
import { liveUsageMgmtResourceViewIsWithoutFiltersSelector } from "@/store/live-usage-mgmt/selectors/resource-type-data/liveUsageMgmtResourceViewIsWithoutFiltersSelector";
import { liveUsageMgmtFilterTemplatesEnabledSelector } from "@/store/live-usage-mgmt/selectors/filter-template/liveUsageMgmtFilterTemplatesEnabledSelector";
import { gridResourceDataLoadingSelector } from "@/store/resources-grid/selectors/resource-data/gridResourceDataLoadingSelector";

interface LiveResourcesGridFilterContentProps {
  masterResourceType: ResourceType;
  masterGridId: string;
  resourceType?: ResourceType;
  totalCount?: number;
  filteredCount?: number;
}

export const LiveResourcesGridFilterContent: FC<
  LiveResourcesGridFilterContentProps
> = ({
  masterResourceType,
  masterGridId,
  resourceType,
  totalCount,
  filteredCount,
}) => {
  const filtersApplied = useAppSelector((state) =>
    isLiveUsageMgmtFilterAppliedToResourceSelector(state, masterResourceType),
  );

  const viewIsWithoutFilters = useAppSelector((state) =>
    liveUsageMgmtResourceViewIsWithoutFiltersSelector(
      state,
      masterResourceType,
    ),
  );

  const filterTemplatesEnabled = useAppSelector(
    liveUsageMgmtFilterTemplatesEnabledSelector,
  );

  const isLoading = useAppSelector((state) =>
    gridResourceDataLoadingSelector(state, masterGridId),
  );

  return (
    <Stack direction="row" spacing={0.5}>
      {!viewIsWithoutFilters && filterTemplatesEnabled && (
        <LiveUsageResourceFilter resourceType={masterResourceType} />
      )}

      <LiveUsageMgmtResourcesCount
        isLoading={isLoading}
        dataCount={filteredCount ?? 0}
        totalDataCount={totalCount ?? 0}
        filtersApplied={filtersApplied}
        masterResourceType={masterResourceType}
        resourceType={resourceType}
      />
    </Stack>
  );
};
